import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
import { scrollToForm } from '../utils/scrollToForm';
export function Hero() {
  const [isPlaying, setIsPlaying] = useState(false);
  return <section id="vsl" className="relative bg-black md:min-h-screen flex items-center pt-24 pb-12 md:pt-32 md:pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-36" data-mp="9lbgx39jxfen">
      {/* Restrained depth: a neutral lift at the top, no colored wash */}
      <div className="absolute inset-x-0 top-0 h-[60vh] bg-gradient-to-b from-white/[0.04] to-transparent pointer-events-none" data-id="element-37" data-mp="xano5xlbjdeb" />

      <div className="relative z-10 max-w-4xl mx-auto w-full text-center" data-id="element-38" data-mp="sa9q98dflju0">
        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-[11px] font-semibold tracking-[0.3em] uppercase text-gold mb-6" data-id="element-39" data-mp="ncgiwc0e6js5">
          Restauración de crédito
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-3xl md:text-5xl lg:text-[3.4rem] font-semibold text-white leading-[1.15] tracking-tight mb-5 max-w-3xl mx-auto" data-id="element-40" data-mp="3o6khtotcoo8a">
          Borramos lo negativo de tu crédito y subimos tu puntuación en{' '}
          <span className="text-gold" data-id="element-41" data-mp="2qlelycqlb6ah">45 a 90 días</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-base md:text-lg text-white/80 font-normal leading-relaxed mb-8 md:mb-11 max-w-xl mx-auto" data-id="element-42" data-mp="2vjzowjx8842m">
          Mira el video para entender cómo funciona el proceso.
        </motion.p>

        {/* Video */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.97,
        y: 24
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-43" data-mp="ichx2zikc81y">
          <div className="relative aspect-video rounded-xl overflow-hidden bg-ink-850 ring-1 ring-white/12 shadow-2xl shadow-black/60" data-id="element-44" data-mp="111ycesywq52f">
            {!isPlaying ? <>
                <div className="absolute inset-0 bg-cover bg-center" style={{
              backgroundImage: "url('https://cdn.magicpatterns.com/uploads/iscmunNCTmj2gaCHihABZz/Captura_de_pantalla_2026-06-01_a_la(s)_9.56.15_p.m..png')"
            }} data-id="element-45" data-mp="3lsoyezdi9t7k" />
                <div className="absolute inset-0 bg-black/45" data-id="element-46" data-mp="21bpjf7pdbcxi" />

                <button onClick={() => setIsPlaying(true)} className="absolute inset-0 flex items-center justify-center group/play" aria-label="Reproducir video" data-id="element-47" data-mp="269hbq2txd128">
                  <span className="h-16 w-16 md:h-[72px] md:w-[72px] rounded-full bg-gold flex items-center justify-center transition-transform duration-200 ease-out group-hover/play:scale-105" data-id="element-48" data-mp="2fzaoh75szm82">
                    <Play className="h-6 w-6 text-black fill-black ml-0.5" data-id="element-49" data-mp="2p1sapllgkev2" />
                  </span>
                </button>
              </> : <iframe src="https://player.vimeo.com/video/1197541389?autoplay=1&title=0&byline=0&portrait=0" className="absolute inset-0 w-full h-full" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen title="Vantix Credit Solutions" data-id="element-50" data-mp="umpqa2b9nmz0" />}
          </div>
        </motion.div>

        {/* CTA below video */}
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.45,
        ease: [0.16, 1, 0.3, 1]
      }} className="mt-8 md:mt-11" data-id="element-51" data-mp="e8sc3c4dusfc">
          <a href="#calificar" onClick={scrollToForm} className="inline-flex items-center justify-center bg-gold hover:bg-gold-light text-black font-semibold px-8 py-4 rounded-lg transition-colors duration-200 text-base" data-id="element-52" data-mp="3rglptbnegipa">
            Solicitar mi diagnóstico gratuito
          </a>
        </motion.div>
      </div>
    </section>;
}